import { onAuthStateChanged, type User } from "firebase/auth";
import { type ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@/components/ui";
import { auth } from "@/lib/firebase/config";

export function PrivateRoute({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, (next) => {
      setUser(next);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }
  return user ? <>{children}</> : <Navigate to="/login" replace />;
}
